module.exports = __webpack_public_path__ + "static/images/ico-title@2x.63bf7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-title@2x.png
// module id = jE+/
// module chunks = 6 7